import AuthenticatedDesktopMenu from '@common/components/PageHeader/PageHeaderMenu/AuthenticatedDesktopMenu';
import AuthenticatedMobileMenu from '@common/components/PageHeader/PageHeaderMenu/AuthenticatedMobileMenu';
import type User from '@common/types/models/User';

interface PageHeaderMenuProps {
  user: User;
  mustAcceptEula: boolean | undefined;
  onLogout: () => void;
  openFeedbackPopup?: () => void;
  showBetaFeatures?: boolean;
}

function PageHeaderMenu({
  user,
  mustAcceptEula,
  onLogout,
  openFeedbackPopup,
  showBetaFeatures,
}: Readonly<PageHeaderMenuProps>) {
  return (
    <>
      <div className="hide-screen-small">
        <AuthenticatedDesktopMenu
          user={user}
          logout={onLogout}
          mustAcceptEula={mustAcceptEula}
          showBetaFeatures={showBetaFeatures}
        />
      </div>
      <div className="hide-screen-desktop">
        <AuthenticatedMobileMenu
          logout={onLogout}
          openFeedbackPopup={openFeedbackPopup}
          mustAcceptEula={mustAcceptEula}
          showBetaFeatures={showBetaFeatures}
        />
      </div>
    </>
  );
}

export default PageHeaderMenu;
